module.exports = __webpack_public_path__ + "img/gas-icon-black.fdec5f14.svg";